<!-- Одна строка исходных данных: сохранённое значение, значение расчёта и возврат. -->
<template>
  <div class="plan-norm" :class="{ 'plan-norm--changed': changed }">
    <span class="plan-norm__name">
      <span>{{ row.name }}</span>
      <small>{{ originLabel }}</small>
    </span>
    <span
      class="plan-norm__original"
      :class="{ 'plan-norm__original--changed': changed }"
    >
      <small class="plan-norm__mobile-label">Исходное значение</small>
      {{ formatNumber(row.originalValue) }}
    </span>
    <span class="plan-norm__value">
      <small class="plan-norm__mobile-label">Для расчёта</small>
      <span class="plan-norm__control">
        <PlanCalculationValueInput
          class="plan-norm__field"
          :changed="changed"
          :model-value="value"
          :disabled="!editable"
          :aria-label="`${row.name} для расчёта`"
          @update:model-value="$emit('update-value', $event)"
        />
        <span v-if="row.unit" class="plan-norm__unit">{{ row.unit }}</span>
      </span>
    </span>
    <base-button
      v-if="changed && editable"
      class="plan-norm__restore"
      compact
      icon-only
      variant="ghost"
      icon="restore"
      aria-label="Вернуть значение калькулятора"
      title="Вернуть значение калькулятора"
      @click="$emit('restore')"
    />
  </div>
</template>

<script>
import PlanCalculationValueInput from "@/components/Order/PlanCalculation/Inputs/Value.vue";
import { formatBigNumber } from "@/utils/numberUtils";

export default {
  name: "OrderPlanCalculationNormRow",

  components: { PlanCalculationValueInput },

  props: {
    row: { type: Object, required: true },
    value: { type: [String, Number], default: "" },
    changed: { type: Boolean, default: false },
    editable: { type: Boolean, default: false },
  },

  emits: ["update-value", "restore"],

  computed: {
    originLabel() {
      const origin = this.row.source ? "Из данных заказа" : "Из калькулятора";
      return this.changed ? `${origin} · отличается` : origin;
    },
  },

  methods: {
    formatNumber(value) {
      return formatBigNumber(value);
    },
  },
};
</script>

<style scoped>
.plan-norm {
  min-height: 40px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 110px 130px 36px;
  gap: 10px;
  align-items: center;
  box-sizing: border-box;
  padding: 0 14px;
  border-top: 1px solid #f3f5f9;
  font-size: 14px;
}

.plan-norm--changed {
  border-color: #fde68a;
  background: #fffbeb;
}

.plan-norm__name {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.plan-norm__name small {
  color: #8b93a7;
  font-size: 11px;
  font-weight: 400;
}

.plan-norm--changed .plan-norm__name > span {
  font-weight: 600;
}

.plan-norm--changed .plan-norm__name small {
  color: #854d0e;
}

.plan-norm__original {
  color: #8b93a7;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.plan-norm__original--changed {
  text-decoration: line-through;
}

.plan-norm__value,
.plan-norm__control {
  display: inline-flex;
  align-items: center;
}

.plan-norm__value {
  justify-content: flex-end;
}
.plan-norm__control {
  gap: 6px;
}
.plan-norm__field {
  width: 80px;
}

.plan-norm__unit {
  width: 36px;
  color: #5b6070;
  font-size: 12px;
}

.plan-norm__restore {
  color: #854d0e;
}
.plan-norm__mobile-label {
  display: none;
}

@media (max-width: 768px) {
  .plan-norm {
    grid-template-columns: minmax(0, 1fr) 28px;
    gap: 8px 10px;
    padding: 9px 14px;
  }

  .plan-norm__name {
    grid-column: 1;
  }
  .plan-norm__restore {
    grid-column: 2;
    grid-row: 1;
  }

  .plan-norm__original,
  .plan-norm__value {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    text-align: left;
  }

  .plan-norm__mobile-label {
    display: inline;
    color: #5b6070;
    font-size: 11px;
    font-weight: 400;
    text-decoration: none;
  }

  .plan-norm__field {
    width: 110px;
  }
}
</style>
